import styled, {css} from 'styled-components';

import {mixins} from '../styles';
import {TSize} from '../types';

export type TToggleButton = {
  size?: TSize;
  disabled?: boolean;
  readOnly?: boolean;
  checked?: boolean;
};

const getToggleButtonHeight = ({theme: {dimensions}, size}: TTheme & TToggleButton) => {
  switch (size) {
    case 'L':
      return dimensions.controlHeightL;
    case 'S':
      return dimensions.controlHeightS;
    case 'M':
    default:
      return dimensions.controlHeightM;
  }
};

const getToggleButtonColorStyle = ({
  disabled,
  readOnly,
  checked,
  theme: {palette, branding},
}: TTheme & TToggleButton) => {
  if (disabled) {
    return css`
      cursor: not-allowed;
      background-color: ${checked ? palette.grey300 : branding.backgrounds.secondary};
    `;
  }

  if (readOnly) {
    return css`
      cursor: auto;
      background-color: ${checked ? palette.grey300 : branding.backgrounds.secondary};
    `;
  }

  if (checked) {
    return css`
      cursor: default;
      color: ${palette.white};
      background-color: ${palette.grey900};
    `;
  }

  return css`
    cursor: pointer;
    color: ${branding.content.secondary};
    background-color: ${palette.grey200};
    &:hover {
      color: ${palette.white};
      background-color: ${palette.grey300};
    }
  `;
};

export const ToggleButton = styled.label<TToggleButton>`
  position: relative;
  ${mixins.flexAlign('center')}
  max-width: max-content;
  height: ${getToggleButtonHeight}px;
  padding: 0 ${({theme: {spacing}}) => spacing.s4};
  ${getToggleButtonColorStyle}
`;

export const Label = styled.label`
  display: flex;
  padding: ${({theme: {spacing}}) => `${spacing.s2} ${spacing.s5}`};
`;
